import Feature from 'ol/Feature';
import {MultiLineString, Point} from 'ol/geom';
import {Icon, Stroke, Style} from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import {fromLonLat} from 'ol/proj';
import {hexToRGBA} from "@/assets/js/utils";
import {explosion} from "@/animations/effects/explosion";

export function missiles(layer, news, geoJson) {
    let features = new GeoJSON().readFeatures(geoJson, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
    });
    let mlFeature = new Feature({
        geometry: new MultiLineString(features.map(f => f.getGeometry())),
        where: fromLonLat(features[0].get('where')),
        speed: features[0].get('speed')
    });
    mlFeature.setStyle(new Style({
        stroke: new Stroke({
            width: 4,
            color: hexToRGBA(news.color, 0.5),
        }),
    }));
    layer.getSource().addFeature(mlFeature);

    const MISSILE_TICK = 40;

    function missileStyle(rotation) {
        return new Style({
            image: new Icon({
                src: '/images/missile.svg',
                scale: 0.04,
                rotation,
                rotateWithView: true,
            })
        });
    }

    function headingFor(a, b) {
        return Math.atan2(b[0] - a[0], b[1] - a[1]) - Math.PI / 4;
    }

    function animateFeature(feature) {
        if (!feature) return;
        const coords = feature.getGeometry().getCoordinates();
        if (coords.length < 2) return;
        const speed = feature.get('speed');

        const segLen = [];
        let total = 0;
        for (let i = 1; i < coords.length; i++) {
            const l = Math.hypot(coords[i][0] - coords[i - 1][0], coords[i][1] - coords[i - 1][1]);
            segLen.push(l);
            total += l;
        }
        if (total === 0) return;
        const duration = total / speed;

        const missileFeature = new Feature(new Point(coords[0]));
        missileFeature.set('selectable', false);
        missileFeature.setStyle(missileStyle(headingFor(coords[0], coords[1])));
        layer.getSource().addFeature(missileFeature);

        let elapsed = 0;
        let lastSeg = 0;
        const interval = setInterval(() => {
            elapsed += MISSILE_TICK;
            const p = Math.min(1, elapsed / duration);
            const dist = p * total;

            let seg = 0, acc = 0;
            while (seg < segLen.length - 1 && acc + segLen[seg] < dist) {
                acc += segLen[seg];
                seg++;
            }
            const a = coords[seg], b = coords[seg + 1];
            const frac = segLen[seg] > 0 ? (dist - acc) / segLen[seg] : 0;
            missileFeature.setGeometry(new Point([
                a[0] + (b[0] - a[0]) * frac,
                a[1] + (b[1] - a[1]) * frac
            ]));

            if (seg !== lastSeg) {
                lastSeg = seg;
                missileFeature.setStyle(missileStyle(headingFor(a, b)));
            }

            if (p >= 1) {
                clearInterval(interval);
                layer.getSource().removeFeature(missileFeature);
                explosion(layer, coords[coords.length - 1], {
                    color: news.color,
                    fireCount: 4,
                    fireSpread: 500
                });
            }
        }, MISSILE_TICK);
    }

    function startAnimation() {
        features.forEach((feature) => {
            for (let i = 0; i < 4; i++) {
                setTimeout(function () {
                    animateFeature(feature);
                }, i * 400);
            }
        });
    }
    startAnimation();
    setInterval(function () {
        startAnimation();
    }, 5000);

    return {
        getFeature: function () {
            return mlFeature;
        }
    };
}
